import { fromJS } from 'immutable';
import {
  CREATE_CERTIFICATION_PATHWAY_START,
  SET_CERTIFICATION_DATA,
  FETCH_STUDENT_CERTIFICATIONS_SUCCESS,
  FETCH_STUDENT_CERTIFICATIONS_FAILURE,
  FETCH_STUDENT_CERTIFICATIONS_START,
} from './actions';
import { COURSE_NAVIGATION_DATA_SET } from '../CourseNavigationInfo/actions';
import { UPDATE_COURSES } from '../Courses/actions';
import { SAVE_CERTIFICATION_SUCCESS } from '../CourseAdmin/actions';

const initialState = fromJS({
  byCoursePath: {},
  studentCertifications: {
    loading: false,
    lastRequest: {},
    requestId: 0,
    page: 1,
    pageSize: 50,
    hasNextPage: false,
    stateMachine: {},
    enrolmentIds: [],
    canAccessEmails: false,
  },
});

export function Certification(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_COURSES: {
      const { courses } = action;
      let newState = state;
      courses.forEach((course) => {
        const {
          path,
          certification: { type, code, data },
        } = course;
        newState = newState.setIn(
          ['byCoursePath', path],
          fromJS({ type, code, data })
        );
      });
      return newState;
    }
    case SET_CERTIFICATION_DATA:
    case SAVE_CERTIFICATION_SUCCESS: {
      const {
        coursePath,
        certificationData: { type, code, data },
      } = action;
      return state.setIn(
        ['byCoursePath', coursePath],
        fromJS({ type, code, data })
      );
    }
    case CREATE_CERTIFICATION_PATHWAY_START: {
      const { coursePath } = action;
      return state.setIn(['byCoursePath', coursePath, 'isProcessing'], true);
    }
    case COURSE_NAVIGATION_DATA_SET: {
      const { certification, coursePath } = action;
      return state.mergeIn(['byCoursePath', coursePath], fromJS(certification));
    }
    case FETCH_STUDENT_CERTIFICATIONS_START: {
      const { requestId, filters } = action;
      return state.mergeIn(['studentCertifications'], {
        loading: true,
        requestId,
        lastRequest: fromJS(filters),
      });
    }
    case FETCH_STUDENT_CERTIFICATIONS_SUCCESS: {
      const {
        page,
        pageSize,
        hasNextPage,
        stateMachine,
        enrolments,
        requestId,
        canAccessEmails,
      } = action;

      const currentRequestId = state.getIn([
        'studentCertifications',
        'requestId',
      ]);

      if (requestId !== currentRequestId) {
        return state;
      }
      const enrolmentIds = enrolments.map((enrolment) => enrolment.id);
      return state.mergeIn(['studentCertifications'], {
        loading: false,
        page,
        pageSize,
        hasNextPage,
        stateMachine: fromJS(stateMachine),
        enrolmentIds: fromJS(enrolmentIds),
        canAccessEmails,
      });
    }
    case FETCH_STUDENT_CERTIFICATIONS_FAILURE: {
      const { requestId } = action;

      const currentRequestId = state.getIn([
        'studentCertifications',
        'requestId',
      ]);

      if (requestId !== currentRequestId) {
        return state;
      }

      return state.setIn(['studentCertifications', 'loading'], false);
    }
    default: {
      return state;
    }
  }
}
